module.exports = __webpack_public_path__ + "170206913d99a894e6541efebff66aec.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/session-logo@3x.png
// module id = 996
// module chunks = 0